import { AuthRawModel, UserRawModel } from '@/api/api-raw-models/user-raw-model';
import { UserModel, AuthModel } from '@/models/UserModel';

export const mapUser = (x: UserRawModel): UserModel => ({
  canContact: x.can_contact,
  cityState: x.city_state,
  email: x.email,
  firstName: x.first_name,
  latitude: x.latitude,
  longitude: x.longitude,
  phoneNumber: x.phone_number,
  saved: x.saved,
  username: x.username,
});

export const mapAuth = (x: AuthRawModel): AuthModel => ({
  access: x.access,
  accessExpiresAt: new Date(x.access_expires_at),
  csrf: x.csrf,
  refresh: x.csrf,
  refreshExpiresAt: new Date(x.refresh_expires_at),
  user: mapUser(x.user),
});
